import { simpleGet } from "../apiConfig"

export const getAnalyticSummary = (projectId,analyticExportId) =>
  simpleGet(`/projects/${projectId}/analytic-exports/${analyticExportId}/summary.json`)
